/*
 * File: FancyNumberInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 09 Dec 2021 1:42:30 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { InputNumber } from 'antd';
import Title from 'antd/lib/typography/Title';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { FC } from 'react';

interface QuantityInputProps {
  value: string | undefined;
  placeHolder: string;
  onInputChange: (value: number | string | null) => void;
}

const styles: InlineStylesModel = {
  borderAnimation: {
    // transform: 'translateX(-100%)',
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    zIndex: 2,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    backgroundColor: 'white',
    // backgroundImage: 'linear-gradient(bottom white 50%, lightblue 50%)',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 2,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  },
  numberInput: {
    width: '100%',
    padding: 1
  },
  titleColor: {
    color: '#2F5596'
  }
};

export const QuantityInput: FC<QuantityInputProps> = ({ onInputChange, value, placeHolder }: QuantityInputProps) => {
  const handleParser = (value: string | undefined): string => {
    if (!value) return '0';
    if (value.match(/[&/\\#,+()$~%.'":*?<>{}!]/g)) return '0';

    return value;
  };

  return (
    <div>
      <Title level={5} style={styles.titleColor}>
        {placeHolder}
      </Title>
      <InputNumber style={styles.numberInput} onChange={onInputChange} value={value} min={'0'} parser={handleParser} />
    </div>
  );
};
